import StatisticsPanel from "../Components/Statistics/StatisticsPanel";
import styles from "../Styles/dashboard.module.css";
import { StatisticsPageProps } from "../Utils/Types";
import { Grid } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { useState, useEffect } from "react";
import { getData } from "../Services/getData";
import { endpoints } from "../Utils/UrlEnum";
import { StatisticItem } from "../Utils/Models";

export default function Statistics(props: StatisticsPageProps) {

  const clientId = localStorage.getItem("clientId") || "";
  const [statistics, setStatistics] = useState<StatisticItem>();
  useEffect(() => {
    getData(`${endpoints.statistics}/${clientId}`).then((response) => {
      if (response.data) setStatistics(response.data);
    });
  }, [clientId]);

  return (
    <div className={styles.mainContainer}>
      <Grid container spacing={2}>
        <div className={styles.container}>

          <div className={styles.panelsContainer}>
            {/* Exam Stats */}
            {statistics && (
              <StatisticsPanel
                title={Vocabulary.examStatistics || ""}
                statistics={statistics.examStats}
                defaultOpen={true}
              />
            )}
            {/* Exam Stats */}
            {/* TODO: ENABLE THIS ONCE READY */}
            {/* {statistics && (
              <StatisticsPanel
                title={Vocabulary.learningStatistics || ""}
                subtitle={`${Vocabulary.examCategory} ${autoCategory}`}
                statistics={statistics.learningStats}
                defaultOpen={true}
              />
            )} */}
          </div>
        </div>
      </Grid>
    </div>
  );
}
